import React from 'react';

const AVAILABLE_THEMES = {
  zeefiTheme: 'zeefiTheme'
} as const;

type ObjectValues<T> = T[keyof T];
type Themes = ObjectValues<typeof AVAILABLE_THEMES>;

type ChangeThemeProps = {
  // interface ChangeThemeProps {
  theme: Themes;
  onThemeChange: (updatedTheme: Themes) => void;
  id?: string;
};

const defaultTheme: Themes = 'zeefiTheme';

const defaultThemeContext: ChangeThemeProps = {
  theme: defaultTheme,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
  onThemeChange: (updatedTheme: Themes) => {}
};

const ThemeContext = React.createContext<ChangeThemeProps>(defaultThemeContext);

const useThemeContext = () => React.useContext(ThemeContext);

//HOC
// function withThemeContext<P extends ChangeThemeProps>(
const withThemeContext =
  <P extends ChangeThemeProps>() =>
  (Component: React.ComponentType<P>): React.FC<P> => {
    return (props: P) => (
      <ThemeContext.Consumer>
        {(useThemeProps) => <Component {...props} {...useThemeProps} />}
      </ThemeContext.Consumer>
    );
  };

const ThemeProvider = ({ children }: React.PropsWithChildren) => {
  const [theme, setTheme] = React.useState<Themes>(defaultTheme);

  const onThemeChange = (theme: Themes) => {
    // TODO log
    // console.log('onThemeChange', theme);
    setTheme(theme);
  };

  const contextValue: ChangeThemeProps = {
    onThemeChange,
    theme
  };
  return (
    <ThemeContext.Provider value={contextValue}>
      {children}
    </ThemeContext.Provider>
  );
};
export { ThemeContext, ThemeProvider, type Themes };
